import React from 'react';
import { CheckCircle2, XCircle, MinusCircle } from 'lucide-react';
import { outcome } from '../data/archiveData';

function Badge({ result }) {
  const o = outcome(result);
  if (o === 'won') return <span className="inline-flex items-center gap-1 rounded-full bg-emerald-500/15 px-2.5 py-1 text-xs font-bold uppercase text-emerald-400"><CheckCircle2 className="h-3.5 w-3.5" /> Won</span>;
  if (o === 'lost') return <span className="inline-flex items-center gap-1 rounded-full bg-red-500/15 px-2.5 py-1 text-xs font-bold uppercase text-red-400"><XCircle className="h-3.5 w-3.5" /> Lost</span>;
  return <span className="inline-flex items-center gap-1 rounded-full bg-neutral-500/15 px-2.5 py-1 text-xs font-bold uppercase text-neutral-400"><MinusCircle className="h-3.5 w-3.5" /> Void</span>;
}

function score(r) {
  return outcome(r.result) === 'void' ? '' : r.result.replace(/\s*(won|lost|loss)\s*/i, '').trim();
}

export default function ArchiveTable({ rows }) {
  return (
    <div>
      {/* Mobile: stacked cards */}
      <div className="space-y-3 md:hidden">
        {rows.map((r, i) => (
          <div key={i} className="rounded-xl border border-[#2e2822] bg-[#1b1712] p-4">
            <div className="flex items-center justify-between gap-2">
              <span className="text-xs font-medium text-neutral-400">{r.date}</span>
              <Badge result={r.result} />
            </div>
            <p className="mt-2 font-medium leading-snug text-white">{r.match}</p>
            <div className="mt-3 flex flex-wrap items-center gap-x-5 gap-y-1.5 text-sm">
              <span className="text-neutral-500">Tip: {r.tip === '-' ? <span className="text-neutral-600">—</span> : <span className="font-semibold text-orange-400">{r.tip}</span>}</span>
              <span className="text-neutral-500">Odd: <span className="font-semibold text-neutral-200">{r.odd === '-' ? '—' : r.odd}</span></span>
              {score(r) && <span className="text-neutral-500">Score: <span className="font-semibold text-neutral-200">{score(r)}</span></span>}
            </div>
          </div>
        ))}
      </div>

      {/* Desktop / tablet: table */}
      <div className="hidden overflow-hidden rounded-xl border border-[#2e2822] bg-[#1b1712] md:block">
        <div className="overflow-x-auto">
          <table className="w-full min-w-[640px] text-left text-sm">
            <thead>
              <tr className="bg-[#241e18] text-neutral-300">
                <th className="px-4 py-3 font-heading text-base font-bold uppercase tracking-wide">Date</th>
                <th className="px-4 py-3 font-heading text-base font-bold uppercase tracking-wide">Match</th>
                <th className="px-4 py-3 font-heading text-base font-bold uppercase tracking-wide">Tip</th>
                <th className="px-4 py-3 font-heading text-base font-bold uppercase tracking-wide">Odds</th>
                <th className="px-4 py-3 font-heading text-base font-bold uppercase tracking-wide">Result</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={i} className={`border-t border-[#2e2822] transition-colors hover:bg-white/5 ${i % 2 ? 'bg-[#1b1712]' : 'bg-[#1e1913]'}`}>
                  <td className="whitespace-nowrap px-4 py-3 text-neutral-400">{r.date}</td>
                  <td className="px-4 py-3 font-medium text-white">{r.match}</td>
                  <td className="whitespace-nowrap px-4 py-3">{r.tip === '-' ? <span className="text-neutral-600">—</span> : <span className="rounded bg-orange-500/15 px-2 py-0.5 font-semibold text-orange-400">{r.tip}</span>}</td>
                  <td className="whitespace-nowrap px-4 py-3 font-semibold text-neutral-200">{r.odd === '-' ? '—' : r.odd}</td>
                  <td className="whitespace-nowrap px-4 py-3"><div className="flex items-center gap-2">{score(r) && <span className="font-semibold text-neutral-200">{score(r)}</span>}<Badge result={r.result} /></div></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
